import React from "react";
import { Col, Row } from "react-bootstrap";

const experienceItems = [
  {
    role: "Developer",
    organization: "Landscape Alliance | CIFOR & ICRAF",
    period: "July 2026 - Present",
    points: [
      "Optimize DecisionSAF, an agroforestry decision-support platform, focusing on its interface and consistency.",
      "Review security, maintainability, and usability risks and document findings and test scenarios.",
      "Work with the client to fix issues, redesign the application, and implement features.",
    ],
  },
  {
    role: "Software Engineer",
    organization: "Sanka",
    period: "September 2024 - May 2026",
    points: [
      "Integrated Sanka with 10+ CRM, e-commerce, POS, and ERP platforms including HubSpot, Shopify, and Salesforce.",
      "Built custom applications, extensions, and automated workflows for third-party platforms.",
      "Migrated Django template pages to React and API-based pages.",
      "Developed and maintained end-to-end tests for critical user workflows.",
      "Resolved more than five customer-reported issues or feature requests per day.",
      "Worked with more than six developers to review tickets, plan changes, and resolve technical issues.",
    ],
  },
  {
    role: "Teaching & Research Assistant",
    organization: "Universitas Indonesia",
    period: "February 2022 - July 2024",
    points: [
      "Assisted Discrete Mathematics and Introduction to Computer Organization courses.",
      "Configured and ran LAMMPS simulations for research.",
      "Tested and debugged simulations across more than 10 scenarios and environments.",
    ],
  },
  {
    role: "Back End Developer",
    organization: "PT. Pharos Indonesia",
    period: "August 2023 - December 2023",
    points: [
      "Developed and maintained 10+ Django widgets for a backend-driven UI application framework.",
      "Built stock management functionality across databases, models, APIs, and pages.",
    ],
  },
];

const credentialItems = [
  {
    label: "Education",
    value: "Computer Science, Universitas Indonesia",
    detail: "2020 - 2024",
  },
];

function Experience() {
  return (
    <>
      <div className="experience-list">
        {experienceItems.map((item) => (
          <article className="experience-entry" key={`${item.role}-${item.organization}`}>
            <header>
              <h2>{item.role}</h2>
              <p className="experience-organization">{item.organization}</p>
              <p className="experience-period">{item.period}</p>
            </header>
            <ul className="experience-points">
              {item.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="credentials-shell">
        <div className="credentials-header">
          <h2>Education</h2>
        </div>
        <Row className="g-3 credential-grid justify-content-center">
          {credentialItems.map((item) => (
            <Col md={6} lg={5} key={item.label}>
              <div className="credential-card">
                <strong>{item.value}</strong>
                <p>{item.detail}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default Experience;
